import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{attrs:{"fluid":""}},[_c(VRow,[_c(VCol,{attrs:{"sm":"12","cols":"12"}},[_c('MinionsTable',{key:_vm.refreshKey}),(_vm.fabs)?_c('Fab',{attrs:{"fabs":_vm.fabs},on:{"fab_action":_vm.fabAction}}):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }